'use strict';

/* eslint-disable max-lines-per-function, max-params */

window.KEY_CURRENT_PROPRIEDADE = 'currentPropriedade';
window.EVENT_CHANGE_PROPRIEDADE = 'changePropriedade';

window.KEY_CURRENT_SAFRA = 'currentSafra';
window.EVENT_CHANGE_SAFRA = 'changeSafra';

window.NEED_PROPERTY = [
  '/visitacampo',
  '/recomendacoes',
  '/relatoriovisita',
  '/relatoriofechamento',
  '/tarefas',
  '/propriedade',
  '/plantios',
  '/produtividade',
  '/dashboard',
  '/relatorios',
  '/colheitas',
  '/propriedade',
  '/itens_estoque',
  '/recomendacoes_semeadura',
  /\/ocorrencias_maquinas.*/,
  '/delete-data',
  '/cronograma-fungicidas',
  '/maquinas',
  '/contratos',
  '/pendencias'
];
window.PUBLIC = [
  'login',
  'not_found',
  '500',
  'aparelhos_compativeis'
];

moment.locale('pt-br');

angular
  .module('webAgro1App', [
    'ngAnimate',
    'ngCookies',
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'ngTouch',
    'ui.bootstrap',
    'ui.select',
    'ui.sortable',
    'ngFlash',
    'truncate',
    'color.picker',
    'bootstrapLightbox',
    'infinite-scroll',
    'daterangepicker',
    'ngPrint',
    'dndLists',
    'textAngular',
    'ui.bootstrap-slider',
    'ui.dashboard',
    'googlechart',
    'ng.ckeditor',
    'indexedDB',
    'text-mask',
    'noUiSlider'
  ])
  .config(function($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'views/main.html',
        controller: 'MainCtrl',
        controllerAs: 'main'
      })
      .when('/login', {
        templateUrl: 'views/login.html',
        controller: 'LoginCtrl',
        controllerAs: 'login'
      })
      .when('/parametro', {
        templateUrl: 'views/parametro.html',
        controller: 'ParametroCtrl',
        controllerAs: 'parametro'
      })
      .when('/funcoes', {
        templateUrl: 'views/funcoes/index.html',
        controller: 'FuncoesCtrl',
        controllerAs: 'funcoes'
      })
      .when('/funcoes/new', {
        templateUrl: 'views/funcoes/new.html',
        controller: 'FuncaoCtrl',
        controllerAs: 'funcao'
      })
      .when('/funcoes/:id', {
        templateUrl: 'views/funcoes/show.html',
        controller: 'FuncoesCtrl',
        controllerAs: 'funcoes'
      })
      .when('/funcoes/:id/new', {
        templateUrl: 'views/funcoes/new.html',
        controller: 'FuncaoCtrl',
        controllerAs: 'funcao'
      })
      .when('/funcoes/:id/edit', {
        templateUrl: 'views/funcoes/edit.html',
        controller: 'FuncaoCtrl',
        controllerAs: 'funcao'
      })
      .when('/usuarios', {
        templateUrl: 'views/usuarios/index.html',
        controller: 'UsuariosCtrl',
        controllerAs: 'usuarios'
      })
      .when('/usuarios/new', {
        templateUrl: 'views/usuarios/edit.html',
        controller: 'UsuarioCtrl',
        controllerAs: 'usuario'
      })
      .when('/usuarios/:id', {
        templateUrl: 'views/usuarios/show.html',
        controller: 'UsuariosCtrl',
        controllerAs: 'usuarios'
      })
      .when('/usuarios/:id/edit', {
        templateUrl: 'views/usuarios/edit.html',
        controller: 'UsuarioCtrl',
        controllerAs: 'usuario'
      })
      .when('/propriedade', {
        templateUrl: 'views/propriedade/index.html',
        controller: 'PropriedadeCtrl',
        controllerAs: 'propriedade',
        reloadOnSearch: false
      })
      .when('/dashboard', {
        templateUrl: 'views/dashboard.html',
        controller: 'DashboardCtrl',
        controllerAs: 'dashboard'
      })
      .when('/recomendado_aplicado', {
        templateUrl: 'views/recomendado_aplicado/recomendado_aplicado.html',
        controller: 'RecomendadoAplicadoCtrl',
        controllerAs: 'recomendadoAplicado'
      })
      .when('/timeline', {
        templateUrl: 'views/timeline.html',
        controller: 'TimelineCtrl',
        controllerAs: 'timeline'
      })
      .when('/404', {
        templateUrl: 'not_found.html'
      })
      .when('/expired', {
        templateUrl: 'expired.html'
      })
      .when('/app', {
        templateUrl: 'views/app.html',
        controller: 'AppCtrl',
        controllerAs: 'app'
      })
      .when('/status', {
        templateUrl: 'views/status.html',
        controller: 'StatusCtrl',
        controllerAs: 'status'
      })
      .when('/ocorrencias_maquinas', {
        templateUrl: 'views/ocorrencias_maquinas/index.html',
        controller: 'OcorrenciasMaquinasCtrl',
        controllerAs: 'ocorrenciasMaquinas'
      })
      .when('/ocorrencias_maquinas/new', {
        templateUrl: 'views/ocorrencias_maquinas/edit.html',
        controller: 'OcorrenciaMaquinaCtrl',
        controllerAs: 'ocorrenciaMaquina'
      })
      .when('/ocorrencias_maquinas/:id', {
        templateUrl: 'views/ocorrencias_maquinas/show.html',
        controller: 'OcorrenciasMaquinasCtrl',
        controllerAs: 'ocorrenciasMaquinas'
      })
      .when('/ocorrencias_maquinas/:id/edit', {
        templateUrl: 'views/ocorrencias_maquinas/edit.html',
        controller: 'OcorrenciaMaquinaCtrl',
        controllerAs: 'ocorrenciaMaquina'
      })
      .when('/depositos', {
        templateUrl: 'views/depositos/index.html',
        controller: 'DepositosCtrl',
        controllerAs: 'depositos'
      })
      .when('/depositos/:id', {
        templateUrl: 'views/depositos/show.html',
        controller: 'DepositoCtrl',
        controllerAs: 'deposito'
      })
      .when('/depositos/:id/edit', {
        templateUrl: 'views/depositos/edit.html',
        controller: 'DepositoEditCtrl',
        controllerAs: 'depositoEdit'
      })
      .when('/depositos_padrao', {
        templateUrl: 'views/depositos_padrao/index.html',
        controller: 'DepositosPadraoCtrl',
        controllerAs: 'depositos'
      })
      .when('/plantios', {
        templateUrl: 'views/plantios.html',
        controller: 'PlantiosCtrl',
        controllerAs: 'plantios'
      })
      .when('/glebas', {
        templateUrl: 'views/glebas/index.html',
        controller: 'GlebasCtrl'
      })
      .when('/glebas/:id', {
        templateUrl: 'views/glebas/show.html',
        controller: 'GlebasCtrl'
      })
      .when('/glebas/:id/edit', {
        templateUrl: 'views/glebas/edit.html',
        controller: 'GlebaCtrl'
      })
      .when('/gleba/new', {
        templateUrl: 'views/glebas/edit.html',
        controller: 'GlebaCtrl'
      })
      .when('/integracao_pluviometros', {
        templateUrl: 'views/integracao_pluviometros/upload_files.html',
        controller: 'IntegracaoPluviometrosCtrl'
      })
      .when('/relatoriovisitacustomizado', {
        templateUrl: 'views/relatorio_visita_customizado/index.html',
        controller: 'RelatorioVisitaCustomizadoCtrl'
      })
      .when('/relatoriovisitacustomizado/:id', {
        templateUrl: 'views/relatorio_visita_customizado/index.html',
        controller: 'RelatorioVisitaCustomizadoCtrl'
      })
      .when('/relatorios', {
        templateUrl: 'views/relatorio_visita_customizado/list.html',
        controller: 'RelatoriosVisitaController',
        controllerAs: 'relatorio'
      })
      .when('/relatoriofechamento', {
        templateUrl: 'views/relatorio_fechamento/index.html',
        controller: 'RelatorioFechamentoCtrl'
      })
      .when('/produtividade', {
        templateUrl: 'views/produtividade.html',
        controller: 'ProdutividadeCtrl',
        controllerAs: 'prod'
      })
      .when('/tipos_ocorrencias', {
        templateUrl: 'views/tipos_ocorrencias/index.html',
        controller: 'TiposOcorrenciasCtrl'
      })
      .when('/recomendacao_semeadura/:id?', {
        templateUrl: 'views/recomendacao_semeadura/edit.html',
        controller: 'RecomendacaoSemeaduraNewCtrl',
        controllerAs: 'recomendacaoSemeadura'
      })
      .when('/recomendacoes_semeadura', {
        templateUrl: 'views/recomendacao_semeadura/list.html',
        controller: 'RecomendacoesSemeaduraNewCtrl',
        controllerAs: 'recs'
      })
      .when('/exportador', {
        templateUrl: 'views/exportador.html',
        controller: 'ExportadorCtrl',
        controllerAs: 'exp'
      })
      .when('/cadastro_propriedades', {
        templateUrl: 'views/cadastro_propriedades/index.html',
        controller: 'CadastroPropriedadesCtrl',
        controllerAs: 'cadastroPropriedade'
      })
      .when('/cadastro_propriedades/:id', {
        templateUrl: 'views/cadastro_propriedades/show.html',
        controller: 'CadastroPropriedadesCtrl',
        controllerAs: 'cadastroPropriedade'
      })
      .when('/cadastro_propriedades/:id/edit', {
        templateUrl: 'views/cadastro_propriedades/edit.html',
        controller: 'CadastroPropriedadeCtrl',
        controllerAs: 'cadastroPropriedade'
      })
      .when('/cadastro_propriedade/new', {
        templateUrl: 'views/cadastro_propriedades/edit.html',
        controller: 'CadastroPropriedadeCtrl',
        controllerAs: 'cadastroPropriedade'
      })
      .when('/safras', {
        templateUrl: 'views/safras/index.html',
        controller: 'SafrasCtrl'
      })
      .when('/safras/new', {
        templateUrl: 'views/safras/edit.html',
        controller: 'SafraCtrl'
      })
      .when('/safras/:id/edit', {
        templateUrl: 'views/safras/edit.html',
        controller: 'SafraCtrl'
      })
      .when('/estadios_fenologicos', {
        templateUrl: 'views/estadios_fenologicos/index.html',
        controller: 'EstadiosFenologicosCtrl',
        controllerAs: 'ef'
      })
      .when('/itens_estoque', {
        templateUrl: 'views/cadastros/itens_estoque/list.html',
        controller: 'ItensEstoqueCtrl',
        controllerAs: 'ie'
      })
      .when('/maquinas', {
        templateUrl: 'views/cadastros/maquinas/list.html',
        controller: 'MaquinasCtrl',
        controllerAs: 'mq'
      })
      .when('/colheitas', {
        templateUrl: 'views/colheitas/index.html',
        controller: 'ColheitasCtrl',
        controllerAs: 'colheitas'
      })
      .when('/colheitas/new', {
        templateUrl: 'views/colheitas/new.html',
        controller: 'CadastroColheitaCtrl',
        controllerAs: 'cadastroColheita'
      })
      .when('/colheitas/:id', {
        templateUrl: 'views/colheitas/show.html',
        controller: 'CadastroColheitaCtrl',
        controllerAs: 'cadastroColheita'
      })
      .when('/colheitas/:id/edit', {
        templateUrl: 'views/colheitas/edit.html',
        controller: 'CadastroColheitaCtrl',
        controllerAs: 'cadastroColheita'
      })
      .when('/delete-data', {
        templateUrl: 'views/delete-data.html',
        controller: 'DeleteDataCtrl',
        controllerAs: 'del'
      })
      .when('/gerenciador_dados', {
        templateUrl: 'views/data_manager/index.html',
        controller: 'DataManagerIndexCtrl'
      })
      .when('/cronograma-fungicidas', {
        templateUrl: 'views/cronograma_fungicidas/index.html',
        controller: 'CronogramaFungicidasCtrl',
        controllerAs: '$ctrl'
      })
      .when('/contratos', {
        templateUrl: 'views/contratos/index.html',
        controller: 'ContratosCtrl',
        controllerAs: '$ctrl'
      })
      .when('/pendencias', {
        templateUrl: 'views/pendencias/index.html',
        controller: 'PendenciasCtrl',
        controllerAs: '$ctrl'
      })
      .otherwise({
        redirectTo: '/404'
      });
  })
  .config(function($httpProvider, $compileProvider) {
    $httpProvider.useApplyAsync(true);
    $httpProvider.interceptors.push('RequestInterceptorService');

    if (typeof PRODUCTION !== 'undefined') {
      $compileProvider.debugInfoEnabled(false);
      $compileProvider.commentDirectivesEnabled(false);
      $compileProvider.cssClassDirectivesEnabled(false);
    }
  })
  .config(function($indexedDBProvider) {
    $indexedDBProvider
      .connection('aqilaLocal')
      .upgradeDatabase(1, function(event, db) {
        db.createObjectStore('relatorioVisitaCustomizado', { keyPath: 'key' });
      });
  })
  .run(function($rootScope, $location, $route, $cookies, filterFilter, StorageService, $routeParams) {
    $rootScope.$on('$routeChangeStart', function(event, currRoute) {
      window.gtag('event', 'page_view', {
        page_title: `${$location.host()}${$location.path()}`
      });
      const user = StorageService.get(KEY_USER);

      const isPublic = !!PUBLIC.filter(function(page) {
        return (currRoute.templateUrl || '').indexOf(page) >= 0;
      }).length;

      if (currRoute.templateUrl === 'expired.html') {
        $rootScope.bodyClass = 'no-padding';
      } else {
        $rootScope.bodyClass = null;
      }

      if (!isPublic && !user) {
        event.preventDefault();
        $rootScope.bodyClass = 'login';
        $location.path('/login');
      }

      if (user) {
        $rootScope.signedIn = true;
        $rootScope.currentUser = user;
        $rootScope.doLogout = function() {
          $rootScope.signedIn = false;
          StorageService.clear();

          // clears $rootScope variables for new user
          $rootScope.resetWeb();

          $location.path('/login');
          $cookies.remove('cpfCheck');
          $route.reload();
        };

        /* Verifica se a rota atual precisa de seleção de propriedade*/
        $rootScope.needProperty = NEED_PROPERTY.filter(function(routeNeeded) {
          const value = currRoute.originalPath || '';
          if (typeof routeNeeded === 'string') {
            return value === routeNeeded;
          }
          return value.match(routeNeeded);
        }).length > 0;
        if (!$rootScope.currentPropriedade && $rootScope.needProperty) {
          event.preventDefault();
          $rootScope.bodyClass = 'bg-selecao-propriedades';
          const redirectTo = $location.url();
          $location.path('/').search({ redirectTo: redirectTo });
        }

        $rootScope.setPropriedade = function(propriedade, $event) {
          const redirectTo = $location.search().redirectTo;

          if ($event) {
            const params = {};
            for (const key in $routeParams) {
              params[key] = null;
            }
            $route.updateParams(params);
            $event.preventDefault();
          }

          if (['number', 'string'].includes(typeof propriedade)) {
            propriedade = $rootScope.getPropriedade(propriedade);
          }
          propriedade.gMap = null;
          $rootScope.globalGleba = null;
          $rootScope.currentPropriedade = propriedade;
          try {
            const propriedadeToPersist = _.omit(propriedade, ['map', 'gMap']);
            localStorage.setItem(KEY_CURRENT_PROPRIEDADE, JSON.stringify(propriedadeToPersist));
          } catch (error) {
            console.error('Erro ao salvar propriedade no localStorage', error);
          }

          if (redirectTo) {
            $location.url(redirectTo);
            $rootScope.$broadcast(EVENT_CHANGE_PROPRIEDADE, propriedade);
            return;
          }

          if ($location.path() === '/') {
            $location.path('/propriedade');
          } else {
            $route.reload();
          }

          $rootScope.$broadcast(EVENT_CHANGE_PROPRIEDADE, propriedade);
        };
      }
    });

    $rootScope.isCurrentPath = function(path, equals) {
      if (equals) {
        return $location.path() === path;
      }

      return $location.path().startsWith(path);
    };

    const isLocalDevelopment = typeof PRODUCTION === 'undefined';

    const hmlHosts = [
      'homologacao.aqila.com.br',
      'testesqa.aqila.com.br',
      'testesdetox.aqila.com.br'
      // 'staging.aqila.com.br' // Staging fica fora para ser um "contra-teste"
    ];

    const releaseCandidateHosts = [
      'rc.aqila.com.br',
      'rc-sinc-rabbit.aqila.com.br',
      'rc-automation.aqila.com.br'
    ];

    $rootScope.enableV2Menu = function() {
      const allowedHostsForV2 = [
        ...hmlHosts,
        ...releaseCandidateHosts,
        'agros.aqila.com.br', // Agros Produção
        'comercialagro1.aqila.com.br', // ComercialAgro1 - AQILA_DEMONSTRACAO
        'comercial.aqila.com.br' // ComercialAgro1
      ];

      return allowedHostsForV2.includes(location.host) || isLocalDevelopment;
    };

    $rootScope.enableRelatorioVisitasV2 = function() {
      const allowedHostsForRelatorioVisitasV2 = [
        ...hmlHosts,
        ...releaseCandidateHosts,
        'agros.aqila.com.br', // Agros Produção
        'assessoria.aqila.com.br', // Agros Assesoria
        'agroentrerios.aqila.com.br', // Agro Entre Rios Ltda
        'partner.aqila.com.br', // PARTNER PLANEJAMENTO AGROPECUÁRIO - AMAMBAI\MS
        'agroservice.aqila.com.br', // JULIANO BRITO - JA DE BRITO E CIA LTDA - PRIMAVERA DO LESTE\MT
        'cpa.aqila.com.br', // CPA - CONSULTORIA E PLANEJAMENTO EM AGRONEGÓCIO - DOURADOS\MS
        'rehagro.aqila.com.br', // REHAGRO- RECURSOS HUMANOS NO AGRONEGOCIO
        'maisagro.aqila.com.br', // LEX SILVA FREIRE
        'terramadre.aqila.com.br', // ERRA MADRE PESQUISAS
        'bragro.aqila.com.br', // BR AGRO LTDA - Tiago Brasil
        'agropecuarianfries.aqila.com.br', // NELVO FRIES
        'verdeouro.aqila.com.br', // GERALDO DE SOUZA DUARTE JUNIOR
        'evidenciaagricola.aqila.com.br', // MARCELO PEDRO DE MORAES - EVIDENCIA AGRICOLA
        'evoterra.aqila.com.br', // EVOTERRA CONSULTORIA AGRONOMICA
        'agrofutura.aqila.com.br', // AGROFUTURA COMERCIO REPRESENTAǃO DE INSUMOS AGRIC
        'alianca.aqila.com.br' // ALIANÇA AGROCONSULTORIA LTDA
      ];

      return allowedHostsForRelatorioVisitasV2.includes(location.host) || isLocalDevelopment;
    };

    $rootScope.getPropriedade = function(id) {
      let propriedade = [];

      if (!id || !$rootScope.propriedades) {
        return {};
      }

      if (typeof id === 'number') {
        propriedade = filterFilter($rootScope.propriedades, { id: id }, true);
      } else if (typeof id === 'string') {
        propriedade = filterFilter($rootScope.propriedades, { uuid: id }, true);
      }

      return propriedade[0] || {};
    };
  });

// Bootstraps Angular module with environmment-aware dependency injection limitations
// waiting for everything to be loaded
function BootstrapOnLoad() {
  angular.bootstrap(document.querySelector('body'), ['webAgro1App'], {
    strictDi: typeof PRODUCTION !== 'undefined'
  });

  window.onload = null;
}
window.onload = BootstrapOnLoad;


/* Adicionado método values para Object */
if (!Object.values) {
  Object.values = function(obj) {
    return Object.keys(obj).map(function(key) {
      return obj[key];
    });
  };
}

window.stopPropagation = function(event) {
  if (event) {
    event.stopPropagation();
  }
};

window.preventDefault = function(event) {
  if (event) {
    event.preventDefault();
  }
};

// Não fica visível em produção, ajuda no desenvolvimento
if (typeof PRODUCTION === 'undefined') {
  window.debug = {
    scope: (element) => angular.element(element).scope(),
    rootScope: () => angular.element('body').scope()
  };
}
